export default function Imprint() {
	return (
		<div className="user-select-text">
			<h3>Impressum</h3>

			<h5>Angaben verpflichtend gemäß § 5 Telemediengesetz</h5>
			<p>
				Felix Oppermann
				<br />
				Oppermann Software Development
				<br />
				Hirschberger Straße 27
				<br />
				31135 Hildesheim
			</p>

			<h5>Kontakt</h5>
			<p>
				E-Mail: felix.oppermann90@gmail.com
				<br />
				Telefon: +49 1514 1645284
			</p>
		</div>
	);
}
